export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.triggerId = item != null ? item.triggerId : ''
        this.documentId = item != null ? item.documentId: ''
        this.naam = item != null ? item.naam : '' 
        this.fablet = item != null ? item.fablet : ''
        this.factuurnummer = item != null ? item.factuurnummer : ''
        this.factuurdatum = item != null ? item.factuurdatum : ''
        this.referentie = item != null ? item.referentie : ''
        this.totaalbedrag = item != null ? item.totaalbedrag : undefined
        this.subtotaal = item != null ? item.subtotaal : undefined
        this.btwLaag = item != null ? item.btwLaag : undefined
        this.btwHoog = item != null ? item.btwHoog : undefined
        this.btwNul = item != null ? item.btwNul : undefined
        this.kostenLaag = item != null ? item.kostenLaag : undefined
        this.kostenHoog = item != null ? item.kostenHoog : undefined
        this.kostenNul = item != null ? item.kostenNul : undefined
        this.kostenVerlegd = item != null ? item.kostenVerlegd : undefined
        this.testcontent = item != null ? item.testcontent : ''
        this.testfilename = item != null ? item.testfilename : ''
    }

    copyTriggermelding(triggermelding) {
        this.id = triggermelding != null ? triggermelding.id : undefined
        this.triggerId = triggermelding != null ? triggermelding.triggerId : undefined
        this.documentId = triggermelding != null ? triggermelding.documentId: undefined
        this.factuurnummer = triggermelding != null ? triggermelding.expectedInvoiceNumber : undefined
        this.factuurdatum = triggermelding != null ? triggermelding.expectedInvoiceDate : undefined
        this.referentie = triggermelding != null ? triggermelding.expectedReference : undefined
        this.totaalbedrag = triggermelding != null ? triggermelding.expectedTotalAmount : undefined
        this.btwLaag = triggermelding != null ? triggermelding.expectedVatLow : undefined
        this.btwHoog = triggermelding != null ? triggermelding.expectedVatHigh : undefined
        this.kostenLaag = triggermelding != null ? triggermelding.expectedCostHigh : undefined
        this.kostenHoog = triggermelding != null ? triggermelding.expectedCostLow : undefined
        this.kostenNul = triggermelding != null ? triggermelding.expectedCostNul : undefined
        this.kostenVerlegd = triggermelding != null ? triggermelding.expectedCostMoved : undefined
    }
}